import styled from "styled-components";
import { TasksTodos } from "./TasksTodos";
import { useTranslation } from "@coworker/locales";
import { TaskTabsTypes } from "../../../shared/constants/taskTabsTypes";
import { useOpenTasksFilters } from "../../../TasksOverview/hooks/useOpenTasksFilters";
import { useTeamId, useUID } from "@coworker/app/src/core/auth/useLoggedInUser";
import { useTasksOverview } from "@coworker/apprestructured/src/TasksOverview/hooks/useTasksOverview";
import { DEFAULT_FILTER_VALUES } from "@coworker/apprestructured/src/TasksOverview/constants/defaultFilterValues";
import { TasksTabs } from "@coworker/apprestructured/src/TasksOverview/constants/tasksTabs";
import { useInProgressTasksFilters } from "@coworker/apprestructured/src/TasksOverview/hooks/useInProgressTasksFilters";

const TasksTodosOuterContainer = styled("div")`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 24px;
  padding-top: 16px;
  padding-right: 16px;
  > * {
    width: 100%;
  }
  @media (min-width: 1440px) {
    padding-top: 32px;
    gap: -16px;
    > * {
      width: 49%;
    }
  }
  margin-bottom: 16px;
`;

export const TasksPreview = () => {
  const { t } = useTranslation();
  const {
    useFiltersFactory: useOpenTasksFiltersFactory,
    filterValues: openTasksFilterValues,
    setFilterValues: setOpenTasksFilterValues,
  } = useOpenTasksFilters();
  const openTasksFilters = useOpenTasksFiltersFactory(openTasksFilterValues);
  const {
    useFiltersFactory: useInProgressTasksFiltersFactory,
    filterValues: inProgressTasksFilterValues,
    setFilterValues: setInProgressTasksFilterValues,
  } = useInProgressTasksFilters();
  const inProgressTasksFilters = useInProgressTasksFiltersFactory(
    inProgressTasksFilterValues
  );

  const uid = useUID();
  const teamId = useTeamId();

  const myTasks = useTasksOverview(
    {
      ...DEFAULT_FILTER_VALUES,
      assignedTo: uid,
    },
    TasksTabs.IN_PROGRESS
  );

  const openTasks = useTasksOverview(
    { ...DEFAULT_FILTER_VALUES, assignedTo: teamId },
    TasksTabs.OPEN
  );

  return (
    <TasksTodosOuterContainer>
      <TasksTodos
        title={t("myString")}
        tabType={TaskTabsTypes.MY}
        tasksCount={myTasks.data?.pages[0]?.filteredCount || 0}
        hideViewButton={openTasks.data?.pages[0]?.list.length === 0}
        tasksList={myTasks.data?.pages[0]?.list.slice(0, 3) ?? []}
        isLoading={myTasks?.isLoading as boolean}
        filters={inProgressTasksFilters}
        filterValues={inProgressTasksFilterValues}
        setFilterValues={setInProgressTasksFilterValues}
      />
      <TasksTodos
        title={t("openTasksString")}
        tabType={TaskTabsTypes.OPEN}
        tasksCount={openTasks.data?.pages[0]?.filteredCount || 0}
        tasksList={openTasks.data?.pages[0]?.list.slice(0, 3) ?? []}
        isLoading={openTasks?.isLoading as boolean}
        filters={openTasksFilters}
        filterValues={openTasksFilterValues}
        setFilterValues={setOpenTasksFilterValues}
      />
    </TasksTodosOuterContainer>
  );
};
